import { createReducer } from '@reduxjs/toolkit'

import { TFetchStatus } from 'redux/reducers/Dashboards'

import * as actions from '../../../actions/internal/Customers/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

import { InternalCustomer } from 'types/GlobalCustomer'

export interface InternalCustomerReducerType {
  data: Record<string, InternalCustomer>
  fetchStatus: TFetchStatus
}

const INITIAL_STATE: InternalCustomerReducerType = {
  data: {},
  fetchStatus: 'idle'
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = Object.fromEntries(
        action.payload.map((customer) => [customer.id, customer])
      )
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(actions.updateOneSuccess, (state, action) => {
      state.data[action.payload.id] = action.payload
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
